// Tutorial data for thin film tutorial (Tutorial 4)
// This dynamically loads the actual .txt/.dat files using file processing functions

import Coating_1_Ref from './Coating1_Reflectivity.txt';
import Coating_1_Trans from './Coating1_Transmission.txt';
import Coating_2_Ref from './Coating2_Reflectivity.txt';
import Coating_2_Trans from './Coating2_Transmission.txt';

// Helper function to create a single file
const createSingleFile = async (fileUrl, fileName) => {
  const response = await fetch(fileUrl);
  const content = await response.text();

  return new File(
    [content],
    fileName,
    {
      type: fileUrl.endsWith('.dat') ? 'application/octet-stream' : 'text/plain',
      lastModified: Date.now()
    }
  );
};

// Function to create all tutorial files at once
export const createTutorial4Files = async () => {
  try {
    const files = await Promise.all([
      createSingleFile(Coating_1_Ref, 'Coating1_Reflectivity_Tutorial.txt'),
      createSingleFile(Coating_1_Trans, 'Coating1_Transmission_Tutorial.txt'),
      createSingleFile(Coating_2_Ref, 'Coating2_Reflectivity_Tutorial.txt'),
      createSingleFile(Coating_2_Trans, 'Coating2_Transmission_Tutorial.txt'),
    ]);
    return files;
  } catch (error) {
    console.error('Error loading tutorial data files:', error);
    throw error;
  }
};

export default {
  createTutorial4Files
};
